<script setup lang="ts">
import { isNotNil } from "es-toolkit";

const props = defineProps<{
    name: string | undefined;
    recipient: string | undefined;
    clientData:
        | {
              visualId: string;
              address: string;
          }
        | undefined;
}>();
</script>

<template>
    <table class="rns-table-form">
        <tbody>
            <tr>
                <td>Nama Tagihan</td>
                <td>:</td>
                <td>{{ props.name }}</td>
            </tr>
            <tr>
                <td>Tujuan</td>
                <td>:</td>
                <td>{{ props.recipient }}</td>
            </tr>
            <tr v-if="isNotNil(props.clientData)">
                <td colspan="3">&nbsp;</td>
            </tr>
            <tr v-if="isNotNil(props.clientData)">
                <td>ID Pelanggan</td>
                <td>:</td>
                <td>{{ props.clientData.visualId }}</td>
            </tr>
            <tr v-if="isNotNil(props.clientData)">
                <td>Alamat</td>
                <td>:</td>
                <td>{{ props.clientData.address }}</td>
            </tr>
        </tbody>
    </table>
</template>

<style scoped>
@reference "@/styles/main.css";

.rns-table-form {
    @apply pl-4 w-full;
}

.rns-table-form tr td {
    @apply align-top;
}

.rns-table-form > tbody > tr > td:nth-child(1) {
    @apply font-semibold w-36 pl-4 whitespace-nowrap;
}

.rns-table-form > tbody > tr > td:nth-child(2) {
    @apply w-3 px-2;
}
</style>
